import { useEffect, useRef } from 'react'

interface CopyFallbackDialogProps {
  value?: string
  onClose: () => void
  title?: string
  label?: string
}

export function CopyFallbackDialog({ value, onClose, title = '手动复制讨论上下文', label = 'Codex 讨论上下文' }: CopyFallbackDialogProps) {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const textRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (value && dialog && !dialog.open) {
      dialog.showModal()
      requestAnimationFrame(() => textRef.current?.select())
    }
    if (!value && dialog?.open) dialog.close()
  }, [value])

  if (!value) return null
  return (
    <dialog ref={dialogRef} className="copy-dialog" onClose={onClose} onCancel={onClose}>
      <button type="button" className="dialog-close" onClick={onClose} aria-label="关闭复制窗口">×</button>
      <p className="eyebrow">Clipboard fallback</p>
      <h2>{title}</h2>
      <textarea ref={textRef} readOnly value={value} aria-label={label} />
      <button type="button" className="primary-button" onClick={() => textRef.current?.select()}>全选文本</button>
    </dialog>
  )
}
